/* eslint-disable react-hooks/exhaustive-deps */
import useEditedContent, { IEditedContent } from "src/modules/pe-landing-module/hooks/useEditedContent"
import ContentEditChild from "./ContentEditChild"
import { LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces"

/* Protopia Ecosystem component */
export interface IContentEditChildrenProps {
    parent: Element | null
}
const ContentEditChildren = (props: IContentEditChildrenProps): JSX.Element => { 
    const element: IEditedContent = useEditedContent() 
    const elementDOM = element?.element?.getBoundingClientRect() 
    
    return <div className='pe-content-edit-children position-absolute top left w-100 '>
        {
            !!element?.element &&
            Array.from(element.element.querySelectorAll("[data-primitive-type]") || []).map(el => {
                const id = el.getAttribute("data-primitive-type") 
                return <ContentEditChild
                    key={id}
                    elementDOM={elementDOM!}
                    element={el} 
                    elementData={element}
                    type={id as LANDING_TYPE_CONTENT}
                />
            })
        }
    </div>
}
export default ContentEditChildren